import { PropsWithChildren } from 'react';
import { useRedirect } from 'react-admin';
import { Lock } from '@mui/icons-material';
import { clsx } from 'clsx';
import { Tooltip } from 'antd';

import cls from './initial-card.module.css';
import { LightTooltip } from '@components/LightTooltip';
import { InfoTooltip } from '@components/InfoTooltip';

interface Props {
  left?: string | React.ReactNode | false;
  leftTooltip?: string;
  center?: string | React.ReactNode | false;
  right?: string | React.ReactNode | false;
  link?: string;
  boxClass?: string;
  wrapperClass?: string;
  contentClass?: string;
  autoHeight?: boolean;
  mt?: number;
  mb?: number;
  fullHeight?: boolean;
  extraPadding?: boolean;
  mediumPadding?: boolean;
  riskPadding?: boolean;
  lockText?: string | boolean | null | undefined;
  minHeight?: number;
  height?: string;
  id?: string;
  onPress?: () => void;
  rightMessage?: string;
  rightIcon?: React.ReactNode;
  rightTooltipClass?: string;
  rightTooltipColor?: string;
  noRedirect?: boolean;
  bordered?: boolean;
}

export const InitialCard = ({
  children, left, leftTooltip, center, right, link, boxClass,
  id, noRedirect = false, wrapperClass, contentClass, autoHeight,
  height, mt, mb, fullHeight, rightTooltipClass, rightTooltipColor,
  extraPadding, mediumPadding, riskPadding, lockText,
  minHeight, onPress, rightMessage, rightIcon, bordered,
}: PropsWithChildren<Props>) => {
  const showHeader = left || right || center;
  const redirect = useRedirect();

  const onClick = (e) => {
    if (noRedirect) return;
    if (onPress) return onPress();
    if (link) return redirect(link);
  };

  return (
    <div
      onClick={onClick}
      id={id}
      className={clsx(
        wrapperClass,
        'InitialCard',
        cls.card,
        boxClass,
        autoHeight && cls.autoHeight,
        (link || onPress) && cls.cardWithLink,
        !showHeader && cls.cardWithoutHeader,
        extraPadding && cls.extraPadding,
        mediumPadding && cls.mediumPadding,
        riskPadding && cls.riskPadding,
        fullHeight && cls.fullHeight,
        bordered && cls.bordered,
      )}
      style={{ marginTop: mt, marginBottom: mb, minHeight, height }}>
      {showHeader ? (
        <div className={clsx(
          'InitialCard-header',
          cls.cardHeader,
          !left && !right && center && cls.center,
        )}>
          {left && (
            <div className={clsx('InitialCard-left', cls.cardHeaderLeft)}>
              {left}{leftTooltip && <InfoTooltip className={cls.tooltip} title={leftTooltip} />}
            </div>
          )}
          {center && (
            <div className={clsx('InitialCard-center', cls.cardHeaderCenter)}>{center}</div>
          )}
          {right && (
            <div className={clsx('InitialCard-right', cls.cardHeaderRight)}>{right}</div>
          )}
          {lockText && (
            <LightTooltip extraWidth title={lockText}>
              <Lock className={cls.lockIcon} />
            </LightTooltip>
          )}
          {rightMessage && (
            <Tooltip title={rightMessage} placement="left" className={rightTooltipClass} color={rightTooltipColor} >
              {rightIcon ? rightIcon : (
                <div className={cls.rightIcon}>i</div>
              )}
            </Tooltip>
          )}
        </div>
      ) : null}
      <div className={contentClass}>
        {children}
      </div>
    </div>
  );
};
